import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import { CAT_VEHICLE_TYPE_LIST, CAT_VEHICLE_TYPE_ADD, CAT_VEHICLE_TYPE_DETAIL, CAT_VEHICLE_TYPE_UPDATE } from '../../actions';
import {
  CatalogVehicleTypeListSuccess, CatalogVehicleTypeListError,
  CatalogVehicleTypeAddSuccess, CatalogVehicleTypeAddError,
  CatalogVehicleTypeDetailSuccess, CatalogVehicleTypeDetailError,
  CatalogVehicleTypeUpdateSuccess, CatalogVehicleTypeUpdateError
} from '../../actions';

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => { unsubscribe(); resolve(token); });
    }, reject);
  });
}

const onListAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'catalog/vehicle_type/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

const onAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'catalog/vehicle_type/add', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(data.payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { message: true, data: response };
};

const onDetailAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'catalog/vehicle_type/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

const onUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'catalog/vehicle_type/update', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(data)
  }).then(r => r.json()).catch(err => console.log(err));
  return { message: true, data: response };
};

function* onList(data) {
  try { const response = yield call(onListAsync, data.payload); yield put(CatalogVehicleTypeListSuccess(response.data)); }
  catch (error) { yield put(CatalogVehicleTypeListError(error)); }
}

function* onAdd(data) {
  try {
    const response = yield call(onAddAsync, data);
    if (response.data.status === true) NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
    else if (response.data.status === 'error') NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    yield put(CatalogVehicleTypeAddSuccess(response.data));
  } catch (error) { yield put(CatalogVehicleTypeAddError(error)); }
}

function* onDetail(data) {
  try { const response = yield call(onDetailAsync, data.payload); yield put(CatalogVehicleTypeDetailSuccess(response.data.data)); }
  catch (error) { yield put(CatalogVehicleTypeDetailError(error)); }
}

function* onUpdate(data) {
  try {
    const response = yield call(onUpdateAsync, data.payload);
    if (response.data.status === true) NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
    else if (response.data.status === 'error') NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    yield put(CatalogVehicleTypeUpdateSuccess(response.data));
  } catch (error) { yield put(CatalogVehicleTypeUpdateError(error)); }
}

export function* watchList() { yield takeEvery(CAT_VEHICLE_TYPE_LIST, onList); }
export function* watchAdd() { yield takeEvery(CAT_VEHICLE_TYPE_ADD, onAdd); }
export function* watchDetail() { yield takeEvery(CAT_VEHICLE_TYPE_DETAIL, onDetail); }
export function* watchUpdate() { yield takeEvery(CAT_VEHICLE_TYPE_UPDATE, onUpdate); }

export default function* rootSaga() {
  yield all([fork(watchList), fork(watchAdd), fork(watchDetail), fork(watchUpdate)]);
}
